import { Component, effect, inject, OnInit } from '@angular/core';
import { SharedSignalsService } from '../common/services/shared-signals.service';

@Component({
  selector: 'taly-sharia-board',
  templateUrl: './sharia-board.component.html',
  styleUrl: './sharia-board.component.scss',
  standalone: false,
})
export class ShariaBoardComponent implements OnInit {
  transferSignal = inject(SharedSignalsService);
  textDirection: string;

  constructor() {
    effect(() => {
      this.textDirection = this.transferSignal.textDirection();
    });
  }

  ngOnInit(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
